export default __webpack_public_path__ + "media/carousel/collect-76ad03a0.png";